export default (incomes) => {
  return incomes
    .map((income) => income.amount)
    .reduce((accumulator, current) => accumulator + current, 0);
};